import classNames from "classnames";
import AppContext from "PFApp/app_context";
import NoItems from "PFApp/components/table/no_items";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import PropTypes from "prop-types";
import React, { useContext } from "react";

import css from "./paginated_gantt_chart.less";

const GANTT_MATCH_MONTHS_LIMIT = 6; // for performance
const GANTT_MONTHS_LIMIT = 12; // for performance

const PaginatedGanttChart = ({ data, fetch, ganttComponent }) => {
  const { currentAccount } = useContext(AppContext).store;

  const monthsLimit = currentAccount.availability?.calculated_months_limit || GANTT_MONTHS_LIMIT;
  const matchMonthsLimit = currentAccount.availability?.match_months_limit || GANTT_MATCH_MONTHS_LIMIT;

  const GanttComponent = ganttComponent;

  const noItems = data.entries.length === 0;

  return (
    <div>
      {noItems ? (
        <NoItems itemType={GanttComponent.displayName} />
      ) : (
        <div className={classNames({ [css.loading]: data.loading })}>
          <GanttComponent monthsLimit={monthsLimit} matchMonthsLimit={matchMonthsLimit} data={data} />
          <SimplePagination
            currentPage={data.meta.page}
            handleClick={(number) => fetch({ page: number })}
            totalPages={data.meta.totalPages}
          />
        </div>
      )}
    </div>
  );
};

PaginatedGanttChart.propTypes = {
  data: PropTypes.shape({
    entries: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
    loading: PropTypes.bool
  }).isRequired,
  ganttComponent: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired
};

export default PaginatedGanttChart;
